import React, { useState, useEffect } from "react";
import "./FranchiseFormn.css";
import { IoClose } from "react-icons/io5";

export default function FranchiseForm() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  useEffect(() => {
    // Automatically open form when page loads
    setShowForm(true);
  }, []);

  const toggleForm = () => setShowForm(!showForm);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // WhatsApp number (without +)
    const phoneNumber = "919152023390";

    // Prepare message
    const message = `🌞 *Franchise Enquiry* 🌞

*Name:* ${formData.name}
*Mobile:* ${formData.mobile}
*Email:* ${formData.email}

I'm interested in becoming a Franchise Partner. Please contact me.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    // Open WhatsApp
    window.open(url, "_blank");

    // Close popup and reset form
    setShowForm(false);
    setFormData({ name: "", mobile: "", email: "" });
  };

  return (
    <>
      {showForm && (
        <div className="form-overlay">
          <div className="enquiry-form-container">
            <button className="close-btn" onClick={toggleForm}>
              <IoClose size={22} />
            </button>

            <div className="form-image">
              <img src="./images/Enquiry Form.jpg" alt="Solar panels" />
            </div>

            <div className="form-content">
              <h2 className="form-title text-white">Enquiry Form</h2>
              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile Number"
                  pattern="[0-9]{10}"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <button type="submit" className="submit-btn">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
